import { faBuilding, faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";


function Sidebar() {
  return (
    <aside className="app-sidebar bg-body-secondary shadow" data-bs-theme="dark">

      <div className="sidebar-brand">
        <NavLink to="/dashboard" className="brand-link">
          <span className="brand-text fw-light">Print My Card</span>
        </NavLink>
      </div>


      <div className="sidebar-wrapper">
        <nav className="mt-2">
          <ul
            className="nav sidebar-menu flex-column"
            data-lte-toggle="treeview"
            role="navigation"
            aria-label="Main navigation"
            data-accordion="false"
            id="navigation"
          >
            {/* Company Details */}
            <li className="nav-item">
              <NavLink
                to="/index/companydetails"
                className="nav-link"
                style={({ isActive }) => ({
                  backgroundColor: isActive ? "#757b84ff" : "transparent",
                  color: isActive ? "#fff" : "#adb5bd",
                  borderRadius: "6px",
                  transition: "all 0.3s ease",
                })}
              >

                <FontAwesomeIcon icon={faBuilding} style={{
                  color: "inherit",
                  marginRight: "8px",
                }} />
                <p style={{ margin: 0 }}>Organization Details</p>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/index/studentdetails"
                className="nav-link"
                style={({ isActive }) => ({
                  backgroundColor: isActive ? "#757b84ff" : "transparent",
                  color: isActive ? "#fff" : "#adb5bd",
                  borderRadius: "6px",
                  transition: "all 0.3s ease",
                })}
              >
                <FontAwesomeIcon icon={faGraduationCap}  style={{
                    color: "inherit",
                    marginRight: "8px",
                  }} />
                <p style={{ margin: 0 }}>Student Details</p>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/index/grades"
                className="nav-link"
                style={({ isActive }) => ({
                  backgroundColor: isActive ? "#757b84ff" : "transparent",
                  color: isActive ? "#fff" : "#adb5bd",
                  borderRadius: "6px",
                  transition: "all 0.3s ease",
                })}
              >
                <FontAwesomeIcon icon={faGraduationCap}  style={{
                    color: "inherit",
                    marginRight: "8px",
                  }} />
                  
                <p style={{ margin: 0 }}>Grades</p>
              </NavLink>
            </li>


          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default Sidebar;
